import { Box, Button, CircularProgress, Typography } from '@mui/material'

type ArticleActionBarProps = {
  hasRecoveryDraft?: boolean
  isEditing: boolean
  saving: boolean
  submitting: boolean
  onCancel: () => void
  onSaveDraft: () => void
  onSubmitForReview: () => void
}

export function ArticleActionBar({
  hasRecoveryDraft = false,
  isEditing,
  saving,
  submitting,
  onCancel,
  onSaveDraft,
  onSubmitForReview,
}: ArticleActionBarProps) {
  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 16,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap',
        bgcolor: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(8px)',
        border: '1px solid #d8e0ea',
        borderRadius: 4,
        p: 2,
        boxShadow: '0 10px 24px rgba(15, 76, 129, 0.08)',
      }}
    >
      <Box>
        <Typography variant="body2" fontWeight={700}>
          {isEditing ? 'Editing technote' : hasRecoveryDraft ? 'Draft created' : 'New technote'}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {hasRecoveryDraft
            ? 'Retry will continue the saved draft and remaining uploads'
            : 'Required fields must be filled before submitting for review'}
        </Typography>
      </Box>
      <Box display="flex" gap={1.5} flexWrap="wrap">
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" disabled={saving || submitting} onClick={onSaveDraft}>
          {saving ? <CircularProgress size={20} color="inherit" /> : isEditing ? 'Save Changes' : 'Save Draft'}
        </Button>
        <Button variant="contained" color="success" disabled={saving || submitting} onClick={onSubmitForReview}>
          {submitting ? <CircularProgress size={20} color="inherit" /> : 'Submit for Review'}
        </Button>
      </Box>
    </Box>
  )
}
